export const MOMO_APP_LINK = {
  Android: "https://play.google.com/store/apps/details?id=com.mservice.momotransfer",
  IOS: "https://apps.apple.com/vn/app/id918751511",
};